<div class="modal-header bg-head py-2 d-flex justify-content-between align-items-center">
  <h6 class="modal-title mb-0">Admin : Question Management : List</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 border-bottom headersize py-2">
    <span class="px-4 my-2 path-class" > {{path}}</span>
  </div>
</div>
<div class="p-3 d-flex flex-wrap flex-md-nowrap align-items-center gap-3">

  <!-- Sort Field -->
  <div class="input-group input-group-sm" style="width: auto; min-width: 200px;">
    <label class="input-group-text" for="sortField">Sort by:</label>
    <select
      class="form-select"
      id="sortField"
      [(ngModel)]="sortField"
    >
      <option value="Display_Order">Display Order</option>
      <option value="Creation_Date">Date Created</option>
      <option value="Updated_Date">Date Updated</option>
      <option value="Created_By">Created By</option>
      <option value="Updated_By">Updated By</option>
      <option value="Question_Status_Type_Name">Status</option>
    </select>
  </div>

  <!-- Sort Direction -->
  <div class="input-group input-group-sm" style="width: auto; min-width: 150px;">
    <select
      class="form-select"
      [(ngModel)]="sortDirection"
    >
      <option value="asc">Ascending</option>
      <option value="desc">Descending</option>
    </select>
  </div>

  <!-- Action Selection (Radio Buttons) -->
  <div class="d-flex align-items-center gap-3" style="white-space: nowrap;">
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="questionAction"
        id="relocateOption"
        value="relocate"
        [(ngModel)]="selectedAction"
        (change)="onActionChange()"
      />
      <label class="form-check-label" for="relocateOption">
        Relocate Questions
      </label>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="questionAction"
        id="preEvalOption"
        value="preEvaluation"
        [(ngModel)]="selectedAction"
        (change)="onActionChange()"
      />
      <label class="form-check-label" for="preEvalOption">
        Select for Pre-Evaluation
      </label>
    </div>
  </div>

  <!-- Relocate Button -->
  <div *ngIf="selectedAction === 'relocate'">
    <button
      class="btn btn-sm bl-btn"
      (click)="RelocateQuestions()"
    >
      Relocate Questions
    </button>
  </div>
  <!-- Pre Select Button -->
  <div *ngIf="selectedAction === 'preEvaluation'">
    <button
      class="btn btn-sm bl-btn"
      (click)="OpenCourseSelection()"
    >
      Select Courses for Pre-Evaluation
    </button>
  </div>

</div>


<div class="modal-body m-body pt-0 px-0" >
  <!-- Apply cdkDropListAutoScroll to the parent container -->
  <div
  class="row g-3 px-3 example-container"
  style="height: 80vh; overflow-y: auto;"
  >
  <div class="w-49" *ngFor="let question of FilteredSortedQuestions; let i = index">
<app-question-card
  [question]="question"
  [relocateQuestions]="relocateQuestions"
  [preSelectQuestions]="preSelectQuestions"
  [selectedCourse]="selectedCourse"
  [editQuestions]="true"
  [index]="i"
  (editClicked)="triggerParentFunction($event)"
  (relocateCheckboxChanged)="onRelocateCheckboxChange($event)"
  (preEvalCheckboxChanged)="onPreEvalCheckboxChange($event)">
</app-question-card>


  </div>

  </div>
</div>
<!-- Footer Buttons (Pre-Evaluation Only) -->
<div
  class="modal-footer d-flex justify-content-end gap-2"
  *ngIf="selectedAction === 'preEvaluation' && selectedCourse"
>
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="onPreEvalCancel()"
  >
    Cancel
  </button>

  <button
    type="button"
    class="btn bl-btn"
    [disabled]="selectedPreEvalQuestions.length === 0"
    (click)="onPreEvalSave()"
  >
    Save
  </button>
</div>




